<template>
    <main-section class="main-section--sm">
        <v-row align="center" class="row--xl">
            <v-col cols="12" lg="">
                <v-sheet class="d-inline-block rounded-pill py-2 px-4 px-md-6">
                    <div class="txt txt--lg primary--text font-weight-bold">20년 바이오 제조 전문기업과 성장할 기회!</div>
                </v-sheet>
                <div class="tit-wrap">
                    <h2 class="tit white--text mt-4">
                        <div class="tit--lg">리본바이옴과 함께할 파트너 모집</div>
                        <div class="tit--xl">지금 가입하고 혜택을 받아보세요!</div>
                    </h2>
                </div>
                <p class="txt txt--lg white--text">
                    리본바이옴은 국내 파트너의 자체 브랜드 상품뿐만 아니라, <br class="d-none d-lg-block" />
                    리본바이옴 완제품에 대해서도 해외 수출 활용이 가능하도록 서포트합니다. <br class="d-none d-lg-block" />
                    필요 시 영문 라벨, 패키지, 수출 전용 CoA, 성분표, HS 코드 자료 등을 제공해드리며,
                    <br class="d-none d-lg-block" />
                    자체 유통은 물론 B2B 수출 목적으로도 활용할 수 있습니다.
                </p>
                <div class="btn-wrap btn-wrap--lg">
                    <v-btn to="/partner" min-width="150" x-large>파트너 등록하기</v-btn>
                </div>
            </v-col>
            <v-col cols="auto" class="d-none d-lg-block">
                <v-img src="/images/main/recruitment.png" alt="" max-width="646" />
            </v-col>
        </v-row>
    </main-section>
</template>

<script>
import mainSection from "../inc/main-section.vue";
export default {
    components: { mainSection },
};
</script>

<style lang="scss" scoped>
.main-section {
    background: var(--v-primary-base);
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 40%;
        background: linear-gradient(to bottom, #f0f0f0, transparent);
        opacity: 0.2;
        pointer-events: none;
    }
}
</style>